import {
  Button,
  ButtonProps,
  Flex,
  forwardRef as chakraForwardRef,
  useMergeRefs,
} from '@chakra-ui/react';
import { useAppSelector } from 'app/store';
import { getPlayerHeight } from 'app/store/AudioPlayer/selectors';
import { forwardRef, useMemo, useRef } from 'react';
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
} from 'react-router-dom';
import { useFabPositionUpdate } from 'app/components/Core/ChakraFabButton/hooks';

interface ChakraFabButtonProps extends ButtonProps {
  to?: string;
}

export const ChakraFabButton = chakraForwardRef(
  ({ children, to, ...rest }: ChakraFabButtonProps, ref) => {
    const playerHeight = useAppSelector(getPlayerHeight);
    const buttonRef = useRef<HTMLButtonElement>(null);
    const refs = useMergeRefs(ref, buttonRef);

    const renderLink = useMemo(
      () =>
        forwardRef<HTMLAnchorElement, Omit<RouterLinkProps, 'to'>>(
          (itemProps, ref) => (
            <RouterLink to={to || ''} ref={ref} {...itemProps} />
          )
        ),
      [to]
    );

    useFabPositionUpdate(buttonRef);

    return (
      <Flex justifyContent="flex-end" w="full">
        <Button
          variant="brandFab"
          zIndex="docked"
          as={to ? renderLink : 'button'}
          position="fixed"
          bottom={`${playerHeight + 16}px`}
          right={3}
          ref={refs}
          {...rest}
        >
          {children}
        </Button>
      </Flex>
    );
  }
);
